import { createStyles } from '@material-ui/styles';

const styles = (): any =>
    createStyles({
        svg: {},
    });

export default styles;
